module.exports = __webpack_public_path__ + "static/media/minus-icon.01762e78.svg";